import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, getSize, rem } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var sizes = {
  xs: rem(16),
  sm: rem(20),
  md: rem(24),
  lg: rem(30),
  xl: rem(36)
};
var useStyles = createStyles(function (theme, _ref, _ref2) {
  var labelPosition = _ref.labelPosition;
  var size = _ref2.size;
  return {
    root: {},
    body: {
      display: "flex",
      "&:has(input:disabled) label": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      }
    },
    labelWrapper: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      display: "inline-flex",
      flexDirection: "column",
      WebkitTapHighlightColor: "transparent",
      fontSize: size in sizes ? getSize({
        size,
        sizes: theme.fontSizes
      }) : void 0,
      lineHeight: size in sizes ? getSize({
        size,
        sizes
      }) : void 0,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      cursor: theme.cursorType,
      order: labelPosition === "left" ? 1 : 2
    }),
    description: {
      marginTop: "calc(".concat(theme.spacing.xs, " / 2)"),
      [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm
    },
    error: {
      marginTop: "calc(".concat(theme.spacing.xs, " / 2)"),
      [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm
    },
    label: {
      cursor: theme.cursorType,
      [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm,
      "&:disabled, &[data-disabled]": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      }
    }
  };
});
export default useStyles;